import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { isAPIError } from '@/store/utils/index';
import type { SetPasswordArgs } from '@/types/store.types';
import { normalizeEmail } from '@/utils/strings/strings';

/**
 * Object-based thunk using createAdminAsyncThunk
 * Pattern: createAdminAsyncThunk<Result, Args>
 */
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const setPasswordThunk = createAdminAsyncThunk<void, SetPasswordArgs>(
  'auth/setPassword',
  async({ password, username }, { extra: { authService }, rejectWithValue }) => {
    try {
      await authService.setPassword({ username: normalizeEmail(username), password });
      // no return needed, void
    } catch (error) {
      if (isAPIError(error) && error.fieldErrors !== null) {
        // Correct: rejectWithValue with expected shape
        return rejectWithValue({ fieldErrors: error.fieldErrors });
      }
      throw error;
    }
  }
);
